export const SdkEvents = {
  Init: 0,
  SendMessage: 1
};

export const SdkResult = {
  Success: 0,
  Failed: 1
};

export const SdkMessages = {
  Init: 'Init Patient App',
  SuccessInit: 'Patient App is Alive',
  SuccessSave: 'Patient was successfully Saved',
  FailureSave: 'Failed to save patient',
  PatientAlreadyExists: 'Patient already exists'
};

export const sdkRawMessage = {
  sdkRequest: {
    origin: '*',
    message: '',
    result: '',
    event: ''
  },
  data: {
    eventId: null,
    data: null
  }
};

export const rxEventTypes = {
  patientAppReady: 100,
  patientAppAddPatient: 101,
  patientAppSelectedPatient: 102,
  patientAppUpdateHostPatient: 103,
  patientAppSelectedPatientConflict: 104,
  patientAppSetPatientValidationsConfig: 105,
  patientAppRedirect: 106,
  patientAppDialog: 107,
  patientAppCreatePatient: 108,
  patientAppSearchPatient: 109,
  patientAppPatientInConflict: 110,
  patientAppError: 111,
  patientAppCancelConflictPopup: 112,
  patientAppConfirmConflictPopup: 113,
  patientAppClearPatient: 114,
  patientAppInit: 115
};

export const PatientAppName = 'inline-patient-app';
